// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.initial-signup-page {
  margin-bottom: 60px;
}
.initial-signup-page .btn-link {
  padding-top: 10px;
}
.initial-signup-page .supportArticle h3 {
  font: 24px Omnes-ATT-W02-Medium;
  margin-top: 20px;
}
.initial-signup-page .supportArticle ul {
  list-style-type: disc;
}
.initial-signup-page .supportArticle li {
  list-style-type: disc;
}
.initial-signup-page .supportArticle .padding {
  padding-left: 38px;
}
@media (max-width: 1024px) {
  .initial-signup-page {
    margin-bottom: 30px;
  }
}

.disableLabel {
  cursor: auto;
}

h1 {
  margin-top: 30px;
}

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}

h3 {
  font: 24px "Omnes-ATT-W02";
  margin-top: 30px;
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  h3 {
    font: 16px "Omnes-ATT-W02-Medium";
  }
}

.heading-small-content-ibm {
  font: 18px "Omnes-ATT-W02-Medium" !important;
  margin-bottom: 10px;
}
@media (max-width: 1024px) {
  .heading-small-content-ibm {
    font-size: 14px !important;
  }
}

.productselection-description1 {
  margin-bottom: 30px;
}

.productselection-header2 {
  margin-bottom: 30px;
}

h4 {
  font: 18px "Omnes-ATT-W02-Medium";
  margin-bottom: 10px;
}
@media (max-width: 1024px) {
  h4 {
    font: 16px "Omnes-ATT-W02-Medium";
  }
}

.addSpace {
  margin: 30px 0px;
}
@media (max-width: 1024px) {
  .addSpace {
    margin: 20px 0px;
  }
}

.inital-signup-container {
  margin: 0 16.66%;
}
.inital-signup-container h1 {
  padding-left: 5px;
}
.inital-signup-container .live {
  padding: 10px 0px 0px 0px;
}
.inital-signup-container .subLabel,
.inital-signup-container input[type=text] {
  font-family: "Omnes-ATT-W02";
  color: #191919;
  font-size: 16px;
}
.inital-signup-container .article {
  padding: 3px;
  margin-left: 15px;
}
.inital-signup-container .subHeader {
  font-size: 22px;
}
.inital-signup-container .error-container .message {
  font-family: "Omnes-ATT-W02";
  font-size: 14px;
  padding: 3px 0;
}
.inital-signup-container .googleId, .inital-signup-container .samsungId {
  padding: 20px 0px 0px 0px;
  display: none;
}
.inital-signup-container .tooltip-container i.tooltip-icon {
  display: none;
}
.inital-signup-container .form-control {
  width: 380px;
}
@media (max-width: 1024px) {
  .inital-signup-container .form-control {
    width: 290px;
  }
}
.inital-signup-container .gtooltip, .inital-signup-container .stooltip {
  bottom: 29px;
  left: 350px !important;
}
@media (max-width: 1024px) {
  .inital-signup-container .gtooltip, .inital-signup-container .stooltip {
    bottom: 30px;
    left: 260px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .inital-signup-container .gtooltip, .inital-signup-container .stooltip {
    bottom: 0px;
    left: -30px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .inital-signup-container i.tooltip-icon::after {
    margin-top: -10px;
  }
}
.inital-signup-container .helper-text {
  left: 340px;
  top: 0px;
}
@media (max-width: 1024px) {
  .inital-signup-container .helper-text {
    left: 0px;
    top: 33px;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .inital-signup-container .helper-text {
    top: 37px;
  }
}
.inital-signup-container #samsung-name-error, .inital-signup-container #google-name-error {
  margin-top: -10px;
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .inital-signup-container #samsung-name-error, .inital-signup-container #google-name-error {
    margin-top: 5px;
  }
}
.inital-signup-container .changeNonIBM, .inital-signup-container .changeIBM {
  border: 1px solid grey;
  border-radius: 15px;
  padding: 15px 15px 5px 15px;
  margin: 20px 0px 20px 0px;
  display: none;
}
.inital-signup-container .selectedDetails, .inital-signup-container .selectedDetailsKme {
  padding: 20px 0px 20px 35px;
  display: none;
}
.inital-signup-container .product-brief-link-kme, .inital-signup-container .product-brief-link-ztp {
  margin-left: 35px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/initial-signup/initial-signup.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,mBAAA;AAkJF;AAjJE;EACE,iBAAA;AAmJJ;AAhJI;EACE,+BAAA;EACA,gBAAA;AAkJN;AAhJI;EACE,qBAAA;AAkJN;AAhJI;EACE,qBAAA;AAkJN;AAhJI;EACE,kBAAA;AAkJN;AF9II;EErBJ;IAsBI,mBAAA;EAiJF;AACF;;AA5IA;EACE,YAAA;AA+IF;;AA5IA;EACE,gBAAA;AA+IF;;AA7IA;EACE,gBAAA;EACA,mBAAA;AAgJF;;AA9IA;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AAiJF;AFtKI;EEkBJ;IAKI,iCAAA;EAmJF;AACF;;AAjJA;EACE,4CAAA;EACA,mBAAA;AAoJF;AFhLI;EE0BJ;IAII,0BAAA;EAsJF;AACF;;AApJA;EACE,mBAAA;AAuJF;;AArJA;EACE,mBAAA;AAwJF;;AAtJA;EACE,iCAAA;EACA,mBAAA;AAyJF;AFlMI;EEuCJ;IAII,iCAAA;EA2JF;AACF;;AAxJA;EACE,gBAAA;AA2JF;AF3MI;EE+CJ;IAGI,gBAAA;EA6JF;AACF;;AAxJA;EAKE,gBAAA;AAuJF;AA1JE;EACE,iBAAA;AA4JJ;AAlJE;EACE,yBAAA;AAoJJ;AAjJE;;EAEE,4BAAA;EACA,cAAA;EACA,eAAA;AAmJJ;AAhJE;EACE,YAAA;EACA,iBAAA;AAkJJ;AA/IE;EACE,eAAA;AAiJJ;AA9II;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AAgJN;AA7IE;EACE,yBAAA;EACA,aAAA;AA+IJ;AA5IE;EACE,aAAA;AA8IJ;AA3IE;EACE,YAAA;AA6IJ;AFtPI;EEwGF;IAGI,YAAA;EA+IJ;AACF;AA5IE;EACE,YAAA;EACA,sBAAA;AA8IJ;AF/PI;EE+GF;IAII,YAAA;IACA,sBAAA;EAgJJ;AACF;AA/II;EAPF;IAQI,WAAA;IACA,sBAAA;EAkJJ;AACF;AA9II;EADF;IAEI,iBAAA;EAiJJ;AACF;AA/IE;EACE,WAAA;EACA,QAAA;AAiJJ;AFpRI;EEiIF;IAII,SAAA;IACA,SAAA;EAmJJ;AACF;AAlJG;EAPD;IASI,SAAA;EAoJJ;AACF;AAjJE;EACE,iBAAA;AAmJJ;AAlJI;EAFF;IAGI,eAAA;EAqJJ;AACF;AAlJE;EACE,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,aAAA;AAoJJ;AAlJE;EACE,2BAAA;EAEA,aAAA;AAmJJ;AAjJE;EACE,iBAAA;AAmJJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.initial-signup-page {\n  margin-bottom: 60px;\n  .btn-link {\n    padding-top: 10px;\n  }\n  .supportArticle{\n    h3 {\n      font: 24px Omnes-ATT-W02-Medium;\n      margin-top: 20px;\n    }\n    ul{\n      list-style-type: disc;\n    }\n    li{\n      list-style-type: disc;\n    }\n    .padding{\n      padding-left:38px;\n    }\n  }\n  \n    @include respond-to (small) {\n    margin-bottom: 30px;\n  }\n}\n\n\n\n.disableLabel{\n  cursor: auto;\n}\n\nh1 {\n  margin-top: 30px;\n}\nhr{\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\nh3 {\n  font: 24px 'Omnes-ATT-W02';\n  margin-top: 30px;\n  margin-bottom: 20px;\n  @include respond-to (small){\n    font: 16px 'Omnes-ATT-W02-Medium';\n  }\n}\n.heading-small-content-ibm {\n  font: 18px 'Omnes-ATT-W02-Medium' !important;\n  margin-bottom: 10px;\n  @include respond-to (small){\n    font-size: 14px !important;\n  }\n}\n.productselection-description1 {\n  margin-bottom: 30px;\n}\n.productselection-header2 {\n  margin-bottom: 30px;\n}\nh4 {\n  font: 18px 'Omnes-ATT-W02-Medium';\n  margin-bottom: 10px;\n  @include respond-to (small){\n    font: 16px 'Omnes-ATT-W02-Medium';\n  }\n}\n\n.addSpace {\n  margin: 30px 0px;\n  @include respond-to (small){\n    margin: 20px 0px;\n  }\n}\n\n\n\n.inital-signup-container {\n\n  h1 {\n    padding-left: 5px;\n  }\n  margin: 0 16.66%;\n\n  // .gId, .kmeId {\n  //   display: none;\n  //   padding: 10px 0px 10px 0px;\n  //   width:40% !important;\n  // }\n\n  .live{\n    padding: 10px 0px 0px 0px;\n  }\n\n  .subLabel,\n  input[type=text] {\n    font-family:'Omnes-ATT-W02';\n    color: #191919;\n    font-size: 16px;\n  }\n\n  .article{\n    padding: 3px;\n    margin-left: 15px;\n  }\n\n  .subHeader{\n    font-size:22px;\n  }\n  .error-container {\n    .message {\n      font-family:'Omnes-ATT-W02';\n      font-size: 14px;\n      padding: 3px 0;\n    }\n  }\n  .googleId, .samsungId{\n    padding: 20px 0px 0px 0px;\n    display: none;\n  }\n\n  .tooltip-container i.tooltip-icon {\n    display: none;\n  }\n\n  .form-control{\n    width:380px;\n    @include respond-to (small){\n      width:290px;\n    }\n  }\n\n  .gtooltip, .stooltip{\n    bottom: 29px;\n    left:350px !important;\n    @include respond-to (small){\n      bottom: 30px;\n      left:260px !important;\n    }\n    @media only screen and (max-width: 1025px) and (min-width: 508px){\n      bottom: 0px;\n      left: -30px !important;\n    }\n  }\n\n  i.tooltip-icon::after { \n    @media only screen and (max-width: 1025px) and (min-width: 508px){\n      margin-top: -10px;\n    }\n  }\n  .helper-text{\n    left: 340px;\n    top: 0px;\n    @include respond-to (small){\n      left: 0px;\n      top: 33px;  \n    }\n   @media only screen and (max-width: 1025px) and (min-width: 508px){\n      // left: -290px;\n      top: 37px;\n   }\n  }\n\n  #samsung-name-error, #google-name-error{\n    margin-top: -10px;\n    @media only screen and (max-width: 1025px) and (min-width: 508px){\n      margin-top: 5px;\n    }\n  }\n\n  .changeNonIBM , .changeIBM{\n    border: 1px solid grey;\n    border-radius: 15px;\n    padding:15px 15px 5px 15px;\n    margin: 20px 0px 20px 0px;\n    display: none;\n  }\n  .selectedDetails, .selectedDetailsKme{\n    padding:20px 0px 20px 35px;\n    //line-height: 45px;\n    display:none;\n  }\n  .product-brief-link-kme, .product-brief-link-ztp {\n    margin-left: 35px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
